import { render, staticRenderFns } from "./I18nLangBar.vue?vue&type=template&id=2d4c610f&scoped=true"
import script from "./I18nLangBar.vue?vue&type=script&lang=js"
export * from "./I18nLangBar.vue?vue&type=script&lang=js"
import style0 from "./I18nLangBar.vue?vue&type=style&index=0&id=2d4c610f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4c610f",
  null
  
)

export default component.exports